//import React from 'react';
import { useParams, Link } from 'react-router-dom';
import  { useState, useEffect, JSXElementConstructor, Key, ReactElement, ReactNode, ReactPortal } from 'react';

const loggedOutArticles = [
  {
    id: 1,
    title: "Article 1",
    excerpt: "This is a short summary of article 1.",
    image: "https://via.placeholder.com/150",
    date: "February 1, 2025",
    content: [
      {
        type: "paragraph",
        text: "Humans have been doing business for thousands of years, and the world of entrepreneurship has been evolving for generations. But being an entrepreneur isn’t just running a business or a company; it's much more than that. Entrepreneurship is about having a vision to create something meaningful with continuous resilience."
      },
      {
        type: "paragraph",
        text: "However, this path can be lonely for many entrepreneurs, especially small and medium-scale ones. Working tirelessly day and night, overcoming several challenges, and missing out on family functions is tough. Yet, remaining in the shadows and not being acknowledged by society can be frustrating."
      },
      {
        type: "paragraph",
        text: "In the ever-evolving business world, being an entrepreneur is more than just running a company; it’s about vision, resilience, and the drive to create something meaningful. Yet, the journey can feel isolating for many small- to medium-sized entrepreneurs. You work tirelessly, face countless challenges, and often remain in the shadows, unacknowledged by society or the market."
      },
      {
        type: "paragraph",
        text: "So, we, Alfa Entrepreneur, come into play at this point. If you genuinely want to give your business the recognition it deserves, along with a community that supports you, then you are at the right place. In this article, we’ll understand what it means to be an Alfa Entrepreneur and what opportunity your business will witness after joining our community."
      },
      {
        type: "heading",
        text: "What is an Alfa Entrepreneur?"
      },
      {
        type: "paragraph",
        text: "Alfa Entrepreneurs are leaders, innovators, and changemakers. As leaders, they have a vision to reach the sky. Alfa Entrepreneurs solve modern-day problems with modern solutions as innovators. Not only this, but Alfa Entrepreneurs are changemakers who have the drive to create something meaningful for society. They are individuals who:"
      },
      {
        type: "list",
        items: [
          {
            title: "Lead the Society",
            description: "Alfa Entrepreneurs have a leadership mindset and can make hard decisions in tough situations. They inspire fellow individuals to follow their path and do a greater good for society."
          },
          {
            title: "Earn Respect in their Industry",
            description: "Alfa Entrepreneurs are the ones who have the power to influence the opinions of people in their industry. They have worked so hard that they are among the highest authorities in their respective fields."
          },
          {
            title: "Changemakers",
            description: "Alfa Entrepreneurs don’t do business just for the sake of earning profits; rather, they work for society. They build businesses around the problems in society, which indeed leave a positive impact on the lives of people."
          },
          {
            title: "Never Quit in Tough Situations",
            description: "Alfa Entrepreneurs have risen from challenges, and they don't get scared from rough situations. When they come across obstacles in their paths, they turn those into stepping stones that lead to success."
          }
        ]
      },
      {
        type: "paragraph",
        text: "So, being an Alfa Entrepreneur means going through a transition from just existing to creating a positive impact in society. From receiving thorns to being celebrated with roses, this is what being an Alfa Entrepreneur looks like."
      }
    ],
    
    contentImage: "/Article1.png", 
  },
  {
    id: 2,
    title: "Article 2",
    excerpt: "This is a short summary of article 2.",
    image: "https://via.placeholder.com/150",
    date: "February 2, 2025",
    content: [
      {
        type: "paragraph",
        text: "Alpha Entrepreneurs are leaders, innovators, and changemakers. As leaders, they have a vision to reach the sky. Alfa Entrepreneurs solve modern-day problems with modern solutions as innovators. Not only this, but Alfa Entrepreneurs are changemakers who have the drive to create something meaningful for society."
      },
      {
        type: "paragraph",
        text: "Alfa Entrepreneurs are business owners who are going through a transition from just existing to creating a positive impact in society. From receiving thorns to being celebrated with roses, this is what being an Alfa Entrepreneur looks like."
      },
      {
        type: "heading",
        text: "Why Should You Join the Alfa Entrepreneur Community?"
      },
      {
        type: "paragraph",
        text: "If you’re fed up with living in the shadows and want to get acknowledged by society in the form of a visionary, a leader, and a changemaker, the Alfa Entrepreneur community is the right place for you. Here are some reasons why:"
      },
      {
        type: "list",
        items: [
          {
            title: "Build an Unbreakable Mindset",
            description: "Becoming an Alfa Entrepreneur begins with you having a focused mindset. We help you train your mind to adopt the qualities of a great leader, a visionary, and a changemaker as a whole. Through mentorship, quality resources, and industry-approved strategies, we assist you in developing the mindset of your dreams."
          },
          {
            title: "Learn from Like-Minded Entrepreneurs",
            description: "The foundation of the Alfa Entrepreneur community relies on the principle of shared knowledge. We’ll help you connect with business owners facing or who have faced challenges similar to yours. Their insights, successes, failures, and learnings will help you get a better analysis of the problems that your business might be facing."
          },
          {
            title: "Networking is the Key to a Successful Business",
            description: "Alfa Entrepreneur believes that to reach fast, you need to walk alone. But to reach far, you need people. Our community will provide you with a network of like-minded entrepreneurs who can relate to your struggles. The ones who understand what you or your business might be going through and genuinely want to contribute to your success story."
          },
          {
            title: "Solve Real-world Problems",
            description: "There are several problems that entrepreneurs, especially those operating in small and medium-scale businesses, face on a day-to-day basis, but no one is addressing those. We address the issues no one else talks about—how to overcome financial roadblocks, scale your operations, and establish your business as a leader in its field."
          }
        ]
      },
      {
        type: "heading",
        text: "Who is the Alfa Entrepreneur Community For?"
      },
      {
        type: "paragraph",
        text: "The Alfa Entrepreneur community is for all those entrepreneurs who have the passion to do something great with their business. This community is for:"
      },
      {
        type: "list",
        items: [
          {
            title: "Entrepreneurs seeking professional advice",
            description: "Entrepreneurs who are looking to overcome obstacles by seeking professional advice from fellow entrepreneurs."
          },
          {
            title: "Young, open-minded entrepreneurs",
            description: "The young generation of entrepreneurs, who are open to learning from the experiences of others."
          },
          {
            title: "Entrepreneurs wanting recognition",
            description: "Entrepreneurs who wish to become respected leaders in their industry but are currently living in the shadows."
          },
          {
            title: "Stuck entrepreneurs ready to grow",
            description: "Entrepreneurs who wish to elevate their business but are feeling trapped in the same routine."
          }
        ]
      },
      {
        type: "heading",
        text: "Join the Movement"
      },
      {
        type: "paragraph",
        text: "The Alfa Entrepreneur isn’t just a label—it’s a mindset, a community, and a journey. It’s a promise from you to your inner self to change from a struggling entrepreneur to a torchbearer in society. A leader who commands respect and drives positive impact for everyone."
      },
      {
        type: "paragraph",
        text: "Joining the Alfa Entrepreneur community isn’t just about getting additional support from fellow entrepreneurs. But it’s about providing you with a space where you matter. Here, your voice is heard, your challenges are addressed, and your success is celebrated as a family."
      },
      {
        type: "paragraph",
        text: "So are you ready to claim your place as an Alfa Entrepreneur? Take the first step towards the promise you made to yourself while starting your business by joining the community today. A promise of a future with respect, recognition, and success."
      }
    ],    
    contentImage: "https://via.placeholder.com/600"
  },
  {
    id: 3,
    title: "Article 3",
    excerpt: "This is a short summary of article 3.",
    image: "https://via.placeholder.com/150",
    date: "February 3, 2025",
    content: [
      {
        type: "paragraph",
        text: "Starting your career as a young entrepreneur might be thrilling, but it comes with never-ending challenges. Your journey might be fuelled by your passion and creativity, but mastering some critical leadership skills is what decides your success."
      },
      {
        type: "paragraph",
        text: "An innovative idea isn't enough to build an entire business from scratch or manage a team of professionals. You need to be able to motivate your team, make tough decisions in unpredictable situations, and sail your boat through many deadly storms."
      },
      {
        type: "paragraph",
        text: "Let’s dive into understanding the 5 leadership skills every young entrepreneur must develop to become the ultimate leader in their fields:"
      },
      {
        type: "list",
        items: [
          {
            title: "Good and Clear Communication",
            description: "Clear communication is the foundation of a great leader. You need to align your thoughts carefully and communicate them with your team members. Whether pitching to an investor or giving your team instructions about a project, you need to communicate your ideas. The struggle of young entrepreneurs to effectively communicate their visions leads to miscommunication and might cause misunderstandings. Having strong communication skills helps in understanding that everyone is on the same page."
          },
          {
            title: "Adaptability",
            description: "The business world is ever-changing and stops for nobody. The market trends that were popular the previous day might become extinct the next day. So you need to keep up with the change and adjust your plans and strategies accordingly to successfully grow your business. Young entrepreneurs who are resistant to market changes might find it difficult to compete in the fast-changing business environment. So, you need to continuously educate yourself about the changes in market forces such as customer behaviour, technological advancements, or economic fluctuations. To stay in the game, stay open-minded, accept criticism, and take lessons from that."
          },
          {
            title: "Strategic Thinking and Vision",
            description: "Young entrepreneurs must have a clear vision about the direction in which they want their businesses to excel. Many young entrepreneurs lose their focus without a clear strategy, which in turn affects their business negatively. A well-defined vision helps you plan a detailed roadmap that guides you in decision-making. Strategic thinking can help you define realistic goals, delegate tasks, and allocate resources according to your vision. However, to get ahead of the competition, you need to keep up with the market trends and restructure your strategy repeatedly depending on the market scenario."
          },
          {
            title: "Making Strong Decisions under Pressure",
            description: "As we know, the business world is ever-changing, and the entrepreneurial journey is a path that comes with surprises. From financial crises to unexpected shifts in market behaviour, young entrepreneurs find themselves in a position where they need to make important decisions without properly evaluating their options. With the fear of failure and the lack of proper evaluation, you might make decisions that can backfire. Strong decision-making skills can help you analyse the situation, evaluate the pros and cons of every option, and choose the correct option that aligns with your vision in the long term. You can also break your decisions into smaller, achievable steps to stay composed under pressure."
          },
          {
            title: "Emotional Intelligence",
            description: "Leadership doesn’t just involve delegating tasks to your team. But creating a good and effective working environment is also an important aspect. So, being a leader, you need to be able to both understand as well as manage yours and your team member’s emotions. This will help you in creating a favourable environment that aligns with your vision. Young entrepreneurs often find it difficult to resolve disputes and provide motivation to their team. Having high emotional intelligence helps you in acknowledging conflicts, resolving problems, and motivating your team. To improve this ability, engage in self-awareness and practice constructive criticism exercises."
          }
        ]
      },
      {
        type: "heading",
        text: "How can Joining Alfa Entrepreneur Help You?"
      },
      {
        type: "paragraph",
        text: "Becoming part of a supportive community like Alfa Entrepreneur that encourages you to stand up for yourself will definitely help you accelerate your business growth. Here’s how:"
      },
      {
        type: "list",
        items: [
          {
            title: "Leadership Development Programs",
            description: "Alfa Entrepreneurs provides materials, organizes training programs, and conducts workshops that help in developing critical strategic thinking, decision-making, and communications."
          },
          {
            title: "Interactive Problem-Solving Sessions",
            description: "You’ll be able to discuss real-world problems that entrepreneurs like you face in their businesses. Also, being part of those interactive sessions will help you enhance your emotional intelligence and ability to adapt in tough situations."
          },
          {
            title: "Professional Networking",
            description: "Being part of the same circle, you’ll be able to grow your network with like-minded and industry professionals. You’ll be able to get their guidance and learn about the do’s and don'ts from their valuable experience."
          },
          {
            title: "Motivational Community",
            description: "Surrounding yourself with like-minded individuals who are passionate towards their businesses will help in creating a motivating environment for yourself. This will keep you motivated and give you a drive to achieve higher goals in your career."
          }
        ]
      },
      {
        type: "paragraph",
        text: "Leadership isn’t something you’re born with; it’s a set of skills you learn and develop over the course of time. Joining Alfa Entrepreneurs will not only help you in developing those 5 valuable leadership skills but also help you grow yourself into a personality you aspire to become."
      },
      {
        type: "paragraph",
        text: "Just remember that the journey to become an Alfa Entrepreneur might be tough, but with the right people and the right environment, you’ll become a leader who achieves goals and inspires many more entrepreneurs in the coming time. Be a part of a greater good; join Alfa Entrepreneurs now!"
      }
    ],    
    contentImage: "https://via.placeholder.com/600"
  },
  {
    id: 4,
    title: "Article 4",
    excerpt: "This is a short summary of article 4.",
    date: "February 4, 2025",
    image: "https://via.placeholder.com/150",
    content: [
      {
        type: "paragraph",
        text: "An entrepreneurial experience is something that everyone wants to have at least once in their life. However, being an entrepreneur is not steady and easy. Entrepreneurship comes with its own set of challenges. However, one skill set is so powerful that it can change the entire scenario of how you conduct your business operations. The tool is ‘Networking.’ It means to connect with people and build a positive relationship with people for your own or a different industry."
      },
      {
        type: "paragraph",
        text: "The key difference between a successful venture and an unsuccessful one is networking. Joining Alfa Entrepreneurs is your one step towards a successful future for your small business. Alfa Entrepreneur isn't just a community but a ground for you to establish healthy networks with like-minded entrepreneurs, communicate with, and get mentored by industry experts."
      },
      {
        type: "heading",
        text: "How Networking with Alfa Entrepreneurs Can Transform Your Small Business Journey"
      },
      {
        type: "list",
        items: [
          {
            title: "Growth in Market Reach",
            description: "As a small business owner, it becomes difficult for you to get a wider market audience. This can hamper your business’s growth in the long run. Alfa Entrepreneur helps your business get exposed to a wider market, as we have a community of entrepreneurs with diverse market demographics. Collaborating with fellow like-minded individuals, exchanging ideas, and helping each other solve obstacles can help you get a good position in a market with more potential customers. Word-of-mouth, cross-promotions, and referrals can help you bring out a different side of your business and improve your brand credibility by becoming more visible to the customers."
          },
          {
            title: "Access to Exclusive Insights",
            description: "Being part of a networking community like Alfa Entrepreneur, you’ll get access to knowledgeable insights from industry leaders of different backgrounds. You’ll be able to exchange ideas and get mentorship from successful entrepreneurs who have established a big name in their respective industry. Being a small business owner, access to expert guidance becomes very difficult. This can often lead you to make costly mistakes that might hamper the growth of your business. So, being an Alfa Entrepreneur yourself, you’ll be able to navigate through those obstacles with expert guidance."
          },
          {
            title: "On-top of Industry Trends",
            description: "The business world is ever-changing. And this continuous evolution makes it hard, especially for small business owners, to keep up with the trends. There can be sudden changes in customer perspective, government rules, taste and preferences, and so on. Being able to cope with these can be exhausting for small business owners. However, joining Alfa Entrepreneurs opens you to webinars and training sessions with industry experts. This will help you stay ahead of your competition, get industry insights, and know about the technological shifts. You’ll be able to keep your business relevant for the long term and accelerate your business’s success."
          },
          {
            title: "Getting out of the Shadows",
            description: "When you are a small business owner with a limited network, it becomes hard for you to overcome all the obstacles you might be facing on a day-to-day basis. It sometimes can feel very isolating and demotivate you a lot. But being a part of a supportive group like Alfa Entrepreneurs can help you get out of the shadow and get both mental and emotional support. Being around like-minded individuals, sharing your problems, listening to their experiences, facing challenges together, and supporting each other like a family is what Alfa Entrepreneur is all about. This not only will help you in growing your business but also make you mentally strong and emotionally balanced."
          }
        ]
      },
      {
        type: "heading",
        text: "How to Get Started with Alfa Entrepreneurs?"
      },
      {
        type: "list",
        items: [
          {
            title: "Join the Community",
            description: "Sign up to become a member. Once joined, introduce yourself to the community and watch your business grow with fellow entrepreneurs."
          },
          {
            title: "Participate in Events",
            description: "In order to build a healthy and meaningful connection, take part in webinars, events, and discussions."
          },
          {
            title: "Utilise Resources",
            description: "Get access to resources from industry experts and navigate your business to ultimate success."
          }
        ]
      },
      {
        type: "paragraph",
        text: "Networking isn’t just about exchanging business cards or emails; it’s about building trust and relationships that provide value. Joining Alfa Entrepreneur will provide you with a platform that will help you stay ahead of your game, get support and guidance from industry experts, and have a supportive family that stands by you in your thicks and thins."
      },
      {
        type: "paragraph",
        text: "You aren’t alone in your entrepreneurial journey. Connect with Alfa Entrepreneurs today and take your first step towards a successful future for your business."
      }
    ],    
    contentImage: "https://via.placeholder.com/600"
  },
  {
    id: 5,
    title: "Article 5",
    excerpt: "This is a short summary of article 5.",
    date: "February 5, 2025",
    image: "https://via.placeholder.com/150",
    content: [
      {
        type: "paragraph",
        text: "At Alfa Entrepreneurs, we believe that walking together is the key to success in the entrepreneurial journey. Keeping this in mind, this platform was designed to foster healthy relationships, build connections, and solve obstacles through mentorship and mutual collaborations."
      },
      {
        type: "paragraph",
        text: "The business world is dynamic, and adapting your business to these changes can be tough for a small business owner. Having a mentor who can help you navigate these obstacles, provide guidance, and share his/her wisdom can be very helpful in fostering your business’s growth."
      },
      {
        type: "heading",
        text: "Why Mentorship Matters at Alfa Entrepreneurs"
      },
      {
        type: "paragraph",
        text: "Being a small business owner, having to do all the tasks is a huge challenge. And to add to it, changes in market forces can be painful if you don’t have a supporting system. The entrepreneurial journey can be very lonely, but you can choose the other path by having a guide who’ll navigate you through all the challenges. Having a mentor has several benefits, such as:"
      },
      {
        type: "list",
        items: [
          {
            title: "Avoiding Costly Mistakes",
            description: "Mentors at Alfa Entrepreneurs are experts who are among the top leaders in their respective industries. Similar to you, they might also have faced obstacles that resonate with yours. Their experience will help you solve those problems without making any mistakes that might cause heavy losses for your business."
          },
          {
            title: "One-on-One Guidance",
            description: "Each industry has its own set of problems and requires different solutions. At Alfa Entrepreneurs, your fellow members can be some of those mentors who will guide you and help you solve specific problems in your industry."
          },
          {
            title: "Motivation and Accountability",
            description: "Being mentored by industry leaders provides you with an environment that helps you bring out your creativity. At Alfa Entrepreneurs, mentors can help you keep your emotions in check and motivate yourself to reach for excellence."
          },
          {
            title: "Networking Opportunities",
            description: "At Alfa Entrepreneurs, you’ll be open to a huge network of like-minded individuals who are successful in their industries. This can help you meet potential clients, partners, investors, etc., and open doors for many more opportunities."
          }
        ]
      },
      {
        type: "heading",
        text: "Growth Through Fellow-Mentorship"
      },
      {
        type: "paragraph",
        text: "They say that your growth lies in what kind of people you hang out with. At Alfa Entrepreneurs, you’ll be in a room with like-minded entrepreneurs who are experts in their field of work. The mentorship that you’ll get from your peers is invaluable. Here’s how you’ll benefit from this:"
      },
      {
        type: "list",
        items: [
          {
            title: "Collaborative Problem-Solving",
            description: "Sometimes it becomes hard to find a solution for the problem you have been facing. At Alfa Entrepreneurs, you can get help from your fellow entrepreneurs, who might suggest a fresh and different perspective that can help you unleash your problem-solving creativity."
          },
          {
            title: "Experienced Network",
            description: "Through Alfa Entrepreneurs, you’ll be able to network with fellow entrepreneurs in your industry. Sharing past stories about successes and failures can help you learn from their experience and implement it in your business."
          },
          {
            title: "Inspiration and Emotion Check",
            description: "Being surrounded by like-minded individuals who are on the journey of building successful businesses can help you get inspiration and keep your emotions in check. At Alfa Entrepreneurs, you’ll get the right support that will drive you towards a successful future."
          },
          {
            title: "Building Healthy Relationships",
            description: "Being mentored by industry leaders can help you improve your communication skills and build relations with your peers. Not only will it build confidence but also establish a network of like-minded entrepreneurs."
          }
        ]
      },
      {
        type: "paragraph",
        text: "At Alfa Entrepreneur, we believe that teamwork and fellowship can help you solve problems that are difficult to navigate alone. Networking with experienced mentors and engaging with fellow entrepreneurs can foster confidence in you. The main goal of entrepreneurship is to learn at every step of the journey where being successful is a byproduct."
      }
    ]
,
    contentImage: "https://via.placeholder.com/600"    
  },
  {
    id: 6,
    title: "Article 6",
    excerpt: "This is a short summary of article 6.",
    date: "February 6, 2025",
    image: "https://via.placeholder.com/150",
    content: [
      {
        type: "paragraph",
        text: "In today's environment, managing a business is like navigating turbulent waters; it's unknown, unpredictable, and extremely competitive. Customers have an abundance of options, the market is congested, and trends shift quickly. Finding the ideal business opportunity in such a setting can be like trying to find a needle in a haystack."
      },
      {
        type: "paragraph",
        text: "The reality is that in a competitive market, opportunities hide rather than vanish. And even when it seems like everything is too much to handle, you can find them if you have the correct attitude, support system, and community."
      },
      {
        type: "paragraph",
        text: "At Alfa Entrepreneurs, we think that the most competitive areas are frequently where possibilities arise. All you need is a new outlook and the guts to dig deeper. Let's examine how an entrepreneur might spot possibilities where others perceive barriers."
      },
      {
        type: "heading",
        text: "1. Look for Gaps, Not Just Trends"
      },
      {
        type: "paragraph",
        text: "Slow down when everyone else is hurrying to follow a trend. The gaps that others ignore are where real opportunity might be found. As business owners, we frequently get sucked into the latest trends. However, what is lacking? That unfulfilled need? No one is responding to that consumer complaint? That's where your company can excel. Speak with your clients. Examine their reviews with a critical eye. Find out what irritates them. That annoyance? That's your covert opportunity."
      },
      {
        type: "heading",
        text: "2. Embrace the Power of Micro-Niching"
      },
      {
        type: "paragraph",
        text: "Whispering to the appropriate people will help you succeed in a market where everyone is shouting. Serve a smaller, targeted group to perfection rather than attempting to serve everyone. Your brand's identity gets stronger the more you focus on it. In all honesty, you don't require millions of clients. A few hundred people who genuinely believe in you are what you need. After switching from mass-market thinking to micro-niche mastery, Alfa Entrepreneurs has witnessed the success of innumerable members. That is the foundation of loyalty."
      },
      {
        type: "heading",
        text: "3. Innovate through Collaboration"
      },
      {
        type: "paragraph",
        text: "Isolation is not the same as competition. Someone else’s insight may lead to your biggest discovery. Alfa Entrepreneurs can help in this situation. Making connections with entrepreneurs who share your interests allows you to view problems from different perspectives. For one person, what appears to be a dead end may serve as the inspiration for invention. For example, a local packaging specialist worked with a member of the food industry. The outcome? An eco-friendly packaging option that significantly increased sales and became their new USP."
      },
      {
        type: "heading",
        text: "4. Follow Problems, Not Just Passion"
      },
      {
        type: "paragraph",
        text: "Yes, passion is your fire. But you're headed for difficulties. The most successful entrepreneurs are those who position their passion as a solution to a real-world problem. Ask yourself, what keeps my client up at night? What would they prefer to be simpler, better, or quicker? Start there, and let your company be the solution."
      },
      {
        type: "heading",
        text: "5. Don’t Be Afraid to Pivot"
      },
      {
        type: "paragraph",
        text: "Opportunities don't always present themselves. They are next to your present route. Perhaps your first strategy is no longer effective. It's all right. You're changing, not failing. Reinvention is encouraged at Alfa Entrepreneurs. Many of our members have achieved success by boldly pursuing a new strategy rather than clinging to the old one. Recall that pivoting does not equate to quitting. It's lining up."
      },
      {
        type: "heading",
        text: "6. Your Network is Your Shortcut"
      },
      {
        type: "paragraph",
        text: "Speed and information are critical in a highly competitive market. And you can obtain both with the aid of your network. You're already doing one of the best things by joining Alfa Entrepreneurs, which is to tap into a collective brain rich in knowledge, insights, and life experiences. It's no longer necessary to travel alone. Ask, give, and develop. You’re not just building a business; you’re building relationships that open doors you didn’t even know existed."
      },
      {
        type: "paragraph",
        text: "There will always be competition in markets. But that doesn’t mean you should back off. It’s an indication to level up. Allow competition to drive your innovation. Allow trials to assist you in becoming clearer. And above all, don't go it alone. We at Alfa Entrepreneurs accompany you in your journey, every stage."
      },
      {
        type: "paragraph",
        text: "You may be surprised to learn what your next opportunity is. Sometimes, all you need is a fresh perspective or a new network of entrepreneurs who recognize your potential even when you are unable to. Become a member of Alfa Entrepreneurs now. Together, we’ll make your company an irresistible market potential."
      }
    ]
,
    contentImage: "https://via.placeholder.com/600"    
  },
      // Add more articles as needed
];

interface ArticleContentItem {
  id: number; // Unique identifier for each article content item
  title?: string; // Optional title for the article or section
  excerpt?: string; // Optional excerpt for the article or section
  type: 'paragraph' | 'heading' | 'list' | 'subheading'; // Type of content: paragraph, heading, list, or subheading
  text?: string; // Content for paragraphs and headings
  value?: string; // Value for subheading content
  image?: string; // Optional image URL
  date?: string; // Optional date for the article or section
  content?: Array<{
    type: 'paragraph' | 'heading' | 'list' | 'subheading'; // Type of content within the article section
    text?: string; // Content for paragraphs and headings within the content
    value?: string; // Value for subheading within the content
    items?: Array<{
      title: string; // Title of the list item
      description?: string; // Optional description of the list item
    }>; // List items for the list type content
  }>; // Array of nested content, useful for structured or multi-part sections
}


const loggedInArticles: ArticleContentItem[] = [
    {
      id: 1,
      title: "Article 1",
      excerpt: "This is a short summary of article 1.",
      image: "https://via.placeholder.com/150",
      date: "February 6, 2025",
      content: [
        {
          type: "paragraph",
          text: "The idea of scaling a business might seem difficult without outside help or debt borrowing, but it is completely achievable if you use the right strategies. Many entrepreneurs believe that the only way to expand their business is to get outside capital. However, what they fail to realize is that debt can create a financial burden and affect the business’s flexibility in the long term. A business can achieve both scalability and financial freedom if it uses the right methods of smart and sustainable growth."
        },
        {
          type: "paragraph",
          text: "Here are some effective strategies that you can use to grow your business without taking on external debt:"
        },
      
        // Strategy 1
        {
          type: "heading",
          text: "1. Reinvest Profits for Self-Funded Growth"
        },
        {
          type: "paragraph",
          text: "The most effective way to keep your business going is to reinvest the profits that you have earned throughout the financial year. The re-invested profits act as fuel that helps in growing the business without having to worry about taking an external debt."
        },
        {
          type: "subheading",
          text: "Applying the Strategy:"
        },
        {
          type: "list",
          items: [
            { 
              title:"",
              description: "Increase your profits by setting the right price for your products and services and eliminating all unnecessary spending."

             },
            { 
              title:"",
              description: "Rather than withdrawing the profits, invest them in marketing tactics that give higher returns, such as organic social media and SEO." 

            },
            { 
              title:"",
              description: "Utilize your profits to expand inventory, hire, marketing or other areas to grow your business." 

            }
          ]
        },
        {
          type: "paragraph",
          text: "By focusing on profitability and strategically reinvesting, you can fund the growth of your business without having to take loans from external sources."
        },
      
        // Strategy 2
        {
          type: "heading",
          text: "2. Use Customer-Funded Growth Strategies"
        },
        {
          type: "paragraph",
          text: "This is one of the most used strategies, generally in the service business. Rather than taking loans, you can allow your customers to fuel your expansion by way of subscriptions, pre-sales and upfront payments."
        },
        {
          type: "subheading",
          text: "Applying the Strategy:"
        },
        {
          type: "list",
          items: [
            {
              title:"",
              description: "Create a recurring income by providing the customers with subscriptions or memberships."
            },
            {
              title:"",
              description: "Pre-sell products or services and provide discounts or rebates to early buyers."
            },
            {
              title:"",
              description: "Give discounts and incentives to the customers paying upfront for yearly services rather than monthly."
            
            }
          ]
        },
        {
          type: "paragraph",
          text: "These strategies will help you create a steady cash flow without having to borrow from external sources."
        },
      
        // Strategy 3
        {
          type: "heading",
          text: "3. Build Strategic Partnerships & Collaborations"
        },
        {
          type: "paragraph",
          text: "Creating strategic alliances can help you expand your business without the need to invest money in it. Working with companies that have a similar audience to yours but aren't in direct competition can open you to a new and wider potential customer base."
        },
        {
          type: "subheading",
          text: "Applying the Strategy:"
        },
        {
          type: "list",
          items: [
            {
              title:"",
              description: "Use a barter system of exchanging products or skilled services rather than paying for high-end services."
            },
            {
              title:"",
              description: "Collaborate on marketing campaigns with companies that have similar values and cater to an audience that can be your potential clients."
            },
            {
              title:"",
              description: "Create affiliate and referral programs to provide customers and partners with rewards for promoting your business."
            }
          ]
        },
        {
          type: "paragraph",
          text: "This strategy will help you increase the speed of your business without adding to the cost."
        },
      
        // Strategy 4
        {
          type: "heading",
          text: "4. Bootstrap & Stay Lean"
        },
        {
          type: "paragraph",
          text: "The simpler meaning of bootstrapping is the optimum utilization of available resources for business and expanding it with the least amount of expenditure. A business can have financially risk-free, steady growth if it correctly uses a lean approach."
        },
        {
          type: "subheading",
          text: "Applying the Strategy:"
        },
        {
          type: "list",
          items: [
            { 
              title:"",
              description: "Make ways to reduce unnecessary expenses, such as working remotely or bargaining for better supplier deals."
            },
            {
              title:"",
              description: "Work on emphasizing email marketing, organic social media, and word-of-mouth recommendations rather than spending money on sponsored ads."
            },
            {
              title:"",
              description: "Rather than hiring full-time staff at an early stage of business, use automation tools and freelancers to complete your work."
            }
          ]
        },
        {
          type: "paragraph",
          text: "By staying lean and utilizing your resources, you can sustainably expand your business."
        },
        {
          type: "heading",
          text: "5. Maximize Efficiency Through Automation & Smart Scaling"
        },
        {
          type: "paragraph",
          text: "The meaning of smart scaling is to only expand your business when the demand justifies it. In simpler terms, when the demand for your products or services goes beyond your production capacity, only then do you invest in your business to meet the growing demand. Using technology to manage the course of action is called automation."
        },
        {
          type: "subheading",
          text: "Applying the Strategy:"
        },
        {
          type: "list",
          items: [
                { 
                  title: "", 
                  description: "Invest in business expansion only after analyzing real demand, not just assumptions." 
                },
                { 
                  title: "", 
                  description: "Use automation tools such as AI chatbots, scheduling tools, and email automation to save both time and money." 
                },
                { 
                  title: "", 
                  description: "Focus on customer retention by providing excellent services, loyalty programs and upselling strategies. Make the customer feel wanted." 
                }
          ]
        },
        {
          type: "paragraph",
          text: "By optimizing available resources and smart scaling, you can minimize the financial risk and guarantee the sustainable growth of your business."
        },
        {
          type: "paragraph",
          text: "Therefore, scaling a business can be achieved risk-free without having to take in heavy debts from outside sources. It can prove to be a smarter way to guarantee sustainable financial stability. You can sustainably expand your company by using all the strategies mentioned above."
        },
        {
          type: "paragraph",
          text: "However, joining Alfa Entrepreneurs can speed up this process by connecting you to a community of like-minded individuals who have experience in using these and other growth strategies. You’ll gain practical insights on smartly scaling your business without depending on loans. By leveraging the power of community, you can take your business to the next level by learning from real-world stories that define success—without worrying about raising loans."
        }
      ],
      contentImage: "https://via.placeholder.com/600"
    },

    {
      id: 2,
      title: "Article 2",
      excerpt: "This is a short summary of article 1.",
      image: "https://via.placeholder.com/150",
      date: "February 7, 2025",
      content: [
        {
          type: "heading",
          text: "Introduction"
        },
          {
            type: "paragraph",
            text: "Becoming an entrepreneur is often symbolised as a glorified path of passion, dedication, hard work and continuous hustle for success. However, this journey can become a lonely path filled with fear and anxiety that is very hard to handle. The pressure to deal with unpredictable market circumstances, become successful and continuously make bold decisions can be overwhelming. This dark side of entrepreneurship can create a huge mental and emotional toll that only a few entrepreneurs can come forward and talk about openly."
        },
          
        {
          type: "heading",
          text: "You’re Not Alone"
          },
        {
          type: "paragraph",
          text: "And if you’re an entrepreneur and you’re also going through the same emotional rollercoaster, then buddy, you aren’t alone in this. Let’s dive deep into the darker side of entrepreneurship and discover some practical ways to navigate through it."
        },
        {
          type: "heading",
          text: "1. The Fear of Failure",
        },
        {
          type: "paragraph",
          text: "The path of entrepreneurship is uncertain. One has to take precautions for all the upcoming, unexpected situations. Be it major financial losses, shifts in customer choices, or changes in the government's rules and regulations, anxiety can reach its peak."
        },
        {
          type: "heading",
          text: "How to Handle It",
        },
        {
          type: "list",
          items: [
            {
              title:"Backup Plans and Financial Safeguards",
              description:"Always prepare for uncertainty by having backup plans and financial safeguards. This ensures stability during tough times, helps manage risks effectively, and keeps your business or goals on track despite unexpected challenges."
            },
            {
              title:"Turn Failure into Fuel for Success",
              description:"Never giving up is key to entrepreneurial success. View failure not as a setback but as a stepping stone. Each challenge offers a lesson that brings you closer to your goals, building resilience, growth, and long-term achievement in your journey."
            },
            {
              title:"Celebrate Small Wins to Build Confidence",
              description:"Acknowledge every victory or achievement, even if it’s a small one. This will help you in building confidence and self-assurance."
            }
          ]
        },
        {
          type: "heading",
          text: "2. The Pressure to Always Hustle",
        },
        {
          type: "paragraph",
          text: "The new culture of continuous hustling and grinding has given the perspective that it’s a crime to take breaks. This attitude has made it hard for entrepreneurs to take breaks, leading to extreme burnout due to continuous hustle."
        },
        {
          type: "heading",
          text: "How to Handle It",
        },
        {
          type: "list",
          items: [
            {
              title:"Balance Health with Self-Care",
              description: "Prioritise both mental and physical health by indulging in self-care activities like exercise, yoga and meditation."
            },
            {
              title:"Set and Stick to Work Hours",
              description: "Pre-define working hours and stick to them unless it’s an emergency."
            },
            {
              title:"Delegate to Elevate",
              description: "Delegate tasks that can be done without your supervision; not everything has to be done by you."
            }
          ]
        },
        {
          type: "heading",
          text: "3. The Loneliness of Entrepreneurship",
        },
        {
          type: "paragraph",
          text: "Entrepreneurs often work for long hours in isolation, take all bold and tough decisions alone, and have limited to zero social interactions. Unlike working in a traditional environment where you have colleagues for social interactions. This creates a feeling of loneliness among entrepreneurs."
        },
        {
          type: "heading",
          text: "How to Handle It",
        },
        {
          type: "list",
          items: [
            {
              title:"Grow with Like-Minded Entrepreneurs",
              description: "Join a community like Alfa Entrepreneurs, where you can have social interactions with like-minded individuals and simultaneously take your business to a wider and bigger horizon."
            },
            {
              title:"Prioritize Work-Life Balance",
              description: "Maintain a work-life balance and take time for family and friends."
            },
            {
              title:"Learn from Experienced Entrepreneurs",
              description: "Learn the art of overcoming this feeling from experienced entrepreneurs who have gone through this phase of entrepreneurship."
            }
          ]
        },
        {
          type: "heading",
          text: "4. Anxiety Over Decision-Making",
        },
        {
          type: "paragraph",
          text: "The journey of entrepreneurship comes with numerous difficult and life-changing decisions that you need to take alone. The fear of making the wrong decision can often lead to overthinking and huge mental stress."
        },
        {
          type: "heading",
          text: "How to Handle It",
        },
        {
          type: "list",
          items: [
            {
              title:"Decide Based on Research, Not Emotions",
              description: "Before making a decision, research all the possible outcomes and make decisions based on that research, not feelings."
            },
            {
              title:"Action Beats Indecision",
              description: "It’s better to take a wrong decision rather than just thinking about the outcome and getting your mind paralyzed."
            },
            {
              title:"Seek Guidance from Mentors",
              description: "Discuss with experienced entrepreneurs and mentors or an entrepreneurial community like Alfa Entrepreneurs."
            }
          ]
        },
        {
          type: "heading",
          text: "5. The Struggle to Maintain Work-Life Balance",
        },
        {
          type: "paragraph",
          text: "There is always a struggle to keep work life and personal life separate. There’s only a thin line keeping the two separate, which often gets overlapped in the entrepreneurial journey."
        },
        {
          type: "heading",
          text: "How to Handle It",
        },
        {
          type: "list",
          items: [
            {
              title:"Put Health Before Opportunity",
              description: "Learn to say no because no opportunity is more important than your health."
            },
            {
              title:"Prioritize Alone Time",
              description: "Schedule alone time for yourself and don’t compromise on that."
            },
            {
              title:"Find Balance with Entrepreneur Communities",
              description: "Join a community like Alfa Entrepreneur and get guidance on how to manage a healthy work-life balance in your entrepreneurial journey."
            }
          ]
        },
        {
          type: "heading",
          text: "Final Thoughts",
        },
        {
          type: "paragraph",
          text: "Entrepreneurship is a challenging journey, but you don’t have to walk through it all alone. Anxiety, fear and loneliness are the dark side of entrepreneurship, which can be handled by prioritizing your mental health, seeking mentorship and connecting with other entrepreneurs."
        },
        {
          type: "heading",
          text: "The Alfa Entrepreneurs Advantage",
        },
        {
          type: "paragraph",
          text: "Joining Alfa Entrepreneur opens your gates to a like-minded entrepreneurial community that understands your journey and assures you of helping you navigate through it. You’ve got our back at every step, whether making a tough decision, sharing a similar experience, or finding a solution for your entrepreneurial problems. Remain strong; look after yourself, and remember: Success is a journey, not a destination."
        }
      ],
      contentImage: "https://via.placeholder.com/600"
      
    },
    {
      id: 3,
      title: "Article 3",
      excerpt: "This is a short summary of article 1.",
      image: "https://via.placeholder.com/150",
      date: "February 8, 2025",
      content: [
        {
          type: "paragraph",
          text: "In the world of entrepreneurship, the journey is often filled with challenges, uncertainties, and the constant need for growth. As an entrepreneur, you are not just building a business; you are also building a brand that reflects your values, vision, and mission. However, the path to success is not always straightforward. It requires resilience, adaptability, and a willingness to learn from both successes and failures."
          },
        {
          type: "heading",
          text: "The Power of Alfa Entrepreneur",
        },
        {
          type: "paragraph",
          text: "The answer is ‘Alfa Entrepreneur’, a group of similar-minded, ambitious entrepreneurs that can help you build the perfect ecosystem for your organic growth. This network both creates a healthy environment for your business and helps you overcome obstacles in your day-to-day business. Let’s dive deep into it:"
        },
        {
          type: "heading",
          text: "1. Build a Product or Service People Can’t Ignore",
          value: "If you want people to talk about your business, you need to give them something exciting to talk about. Your business must deliver value that no one else is providing in the market. Be it your products or services, it should ignite excitement among your potential customers."
        },
        {
          type: "heading",
          text: "Tips",
        },
        {
          type: "list",
          items: [
            {
              title:"",
              description: "Provide the customer with a unique experience that feels personalized and premium."
            },
            {
              title:"",
              description: "Find solutions to a significant problem that no one else is catering to."
            },
            {
              title:"",
              description: "Use storytelling to create a community around your business. It develops a sense of belongingness and loyalty among customers."
            }
          ]
        },
        {
          type: "heading",
          text: "How Alfa Entrepreneurs Help",
        },
        {
          type: "paragraph",
          text: "You’ll get real reviews from fellow experienced entrepreneurs that will help you make your product or service more share-worthy."
        },
        {
          type: "heading",
          text: "2. Create a Referral & Incentive Program",
        },
        {
          type: "paragraph",
          text: "Word of mouth spreads like fire if you receive incentives for sharing information. Create a referral system for both customers and business owners where they are rewarded for bringing new clients to your business."
        },
        {
          type: "heading",
          text: "Tips",
        },
        {
          type: "list",
          items: [
            {
              title:"",
              description: "Give exclusive discounts and products to the customers who share your brand."
            },
            {
              title:"",
              description: "Freebies and discounts in exchange for referrals."
            },
            {
              title:"",
              description: "Collaborate with similar businesses for cross-product promotions."
            }
          ]
        },
        {
          type: "heading",
          text: "How Alfa Entrepreneurs Help",
        },
        {
          type: "paragraph",
          text: "As the community is all about growth with collaborations, your business can find other businesses that have a similar audience. This will help you cross-promote products and services without spending much on paid advertisements."
        },
        {
          type: "heading",
          text: "3. Tap Into the Influence of Community Leaders",
        },
        {
          type: "paragraph",
          text: "In today’s world, the market runs under the influence of community leaders. People trust recommendations from influential leaders. And if a big and respected entrepreneur talks about your business, you can come under the limelight. This can help in increasing trust and credibility."
        },
        {
          type: "heading",
          text: "Tips",
        },
        {
          type: "list",
          items: [
            {
              title:"",
              description: "Get your business featured in community forums, events and magazines."
            },
            {
              title:"",
              description: "Give exclusive deals to key influential entrepreneurs in your industry."
            },
            {
              title:"",
              description: "Collaborate with business leaders and micro-influencers in Alfa Entrepreneurs."
            }
          ]
        },
        {
          type: "heading",
          text: "4. Leverage the Power of Networking",
        },
        {
          type: "paragraph",
          text: "Having a personal connection with a brand gives a sense of belongingness. And when people have this sense of connection, they are more likely to recommend it to others. And being a part of Alfa Entrepreneur, you’ll have numerous benefits, such as:"
        },
        {
          type: "heading",
          text: "Networking Benefits",
        },
        {
          type: "list",
          items: [
            {
              title:"",
              description: "Offering cross-promotion with similar businesses."
            },
            {
              title:"",
              description: "Promoting your brand within their networks."
            },
            {
              title:"",
              description: "Recommending your business to others boosts trust and credibility."
            }
          ]
        },
        {
          type: "heading",
          text: "How Alfa Entrepreneurs Help",
        },
        {
          type: "paragraph",
          text: "Fellow entrepreneurs in the community help your business get more visibility by recommending it to other people. You can also do cross-product and service promotions to tap into a bigger audience."
        },
        {
          type: "heading",
          text: "5. Be Part of Engaging Conversations",
        },
        {
          type: "paragraph",
          text: "You can’t grow your business and make it the talk of the town by staying in isolation. You need to show up to places where the actual talk is happening. You need to be at every place where you can promote your products and services."
        },
        {
          type: "heading",
          text: "Tips",
        },
        {
          type: "list",
          items: [
            {
              title:"",
              description: "Share information and valuable insights that provide value."
            },
            {
              title:"",
              description: "Encourage your existing customers to create user-generated content (UGC) for your brand’s products and services."
            },
            {
              title:"",
              description: "Participate in entrepreneurial groups such as Alfa Entrepreneurs."
            }
          ]
        },
        {
          type: "heading",
          text: "How Alfa Entrepreneurs Help",
        },
        {
          type: "paragraph",
          text: "This community provides you with an environment where you can come together with fellow like-minded entrepreneurs and share knowledge and valuable insights."
        },
        {
          type: "heading",
          text: "Conclusion",
        },
        {
          type: "paragraph",
          text: "Word-of-mouth marketing mostly relies on community, trust and connection. Being part of Alfa Entrepreneur, you will surround yourself with like-minded people who will support you in your lows and cherish you in your highs. With people around you who want to see you win, you can excel at your growth in ways that might seem impossible when you are alone."
        },
        {
          type: "heading",
          text: "Call to Action",
        },
        {
          type: "paragraph",
          text: "Join Alfa Entrepreneurs today and take the first step toward engineered word-of-mouth success!"
        }
      ],
      contentImage: "https://via.placeholder.com/600"
    },
    {
      id: 4,
      title: "Article 4",
      excerpt: "This is a short summary of article 1.",
      image: "https://via.placeholder.com/150",
      date: "February 9, 2025",
      content: [
        {
          type: "heading",
          text: "The Importance of Cash Flow in Business"
        },
        {
          type: "paragraph",
          text: "Revenue is considered the most important parameter for defining a business’s success. But here’s something no one will tell you: you alone can’t get dependent on revenue for sustaining your business. The parameter you must consider to determine whether your business will thrive or struggle is 'Cash Flow'."
        },
        {
          type: "paragraph",
          text: "Have you ever wondered how some companies that generate millions in revenue fail to keep going, whereas other small companies get success with comparatively less revenue? The answer to this mystery is management of cash flow. If you are an entrepreneur who wants to master this game, Alfa Entrepreneur can help you channel your inner player."
        },
        {
          type: "heading",
          text: "Why Cash Flow is More Important than Revenue"
        },
        {
          type: "paragraph",
          text: "Let’s understand why cash flow is more important than revenue for a business and how you can master it."
        },
        {
          type: "heading",
          text: "Bursting the Myth: Revenue ≠ Profit ≠ Cash Flow"
        },
        {
          type: "paragraph",
          text: "What most entrepreneurs do wrong is to celebrate when the business hits high numbers in revenue. They believe that the more revenue, the more the business grows, which in turn gives the business more stability. However, revenue is defined as the total amount of money that flows in. It doesn’t include any expenses, operational costs or outstanding payments due for the business."
        },
        {
          type: "heading",
          text: "Revenue, Profit, and Cash Flow Explained"
        },
        {
          type: "list",
          items: [
            { title: "Revenue", description: "The total amount of money that a business generates is revenue." },
            { title: "Profit", description: "It comes after deducting all the expenses from revenue. However, it doesn’t mean you have cash in hand." },
            { title: "Cash flow", description: "It refers to the actual money that comes in and goes out of a business during a given period." }
          ]
        },
        {
          type: "paragraph",
          text: "Therefore, even after having huge revenue, if the business doesn’t have adequate cash flow, it becomes hard to manage day-to-day expenses or invest in expansions."
        },
        {
          type: "heading",
          text: "Why is Cash Flow Important?"
        },
        {
          type: "paragraph",
          text: "There are several reasons why cash flow is considered the true king in a business. Let’s explore why:"
        },
        {
          type: "list",
          items: [
            { title: "Cash flow offers you control and flexibility", description: "If your business has good cash flow, then you’ll be able to take advantage of new opportunities, get better technology for operations, and invest in business expansion." },
            { title: "You can’t use revenue to pay your bills", description: "Having millions in sales has no meaning if you haven’t received payment from the customers. Many businesses struggle to survive due to late payments from their customers." },
            { title: "Stable cash flow gives you peace of mind", description: "When you don’t have a good and steady cash flow for your business, most of your time gets wasted trying to find ways for survival rather than growing the business." },
            { title: "Growth without cash flow: An invitation to disaster", description: "Many entrepreneurs misinterpret that revenue will pay for all the bills. If the business lacks steady or adequate cash flow, it can lead to huge debts, burnout, and even collapse." },
            { title: "Lenders and Investors care about your cash flow", description: "During expansion, investors and banks first analyze the cash flow of your business to determine if it’s financially healthy and capable of sustainable growth." }
          ]
        },
        {
          type: "heading",
          text: "Mastering Cash Flow: The Smarter Way"
        },
        {
          type: "paragraph",
          text: "After understanding what cash flow is and why it’s important for a business’s growth, let’s explore how you can master it."
        },
        {
          type: "list",
          items: [
            { title: "Reduce unnecessary expenses", description: "Keep your operating expenses intact and efficient. Negotiate better payment terms with vendors. Eliminate unnecessary tools, subscriptions, and services." },
            { title: "Focus on cash flow, not just sales", description: "Introduce subscription models for recurring revenue. Sell higher-margin products. Request advance payments or upfront fees for long-term projects." },
            { title: "Get payments quickly", description: "Offer cash discounts for early payments, automate invoicing, and follow up regularly for a steady cash flow." },
            { title: "Use smart cash flow software", description: "Use apps like Khatabook, Tally, and other tools for maintaining accounts and automating reminders for unpaid invoices." },
            { title: "Maintain a cash reserve", description: "Use profits wisely, don’t reinvest all of it without planning. Maintain a cash reserve for 3-6 months of expenses. Save for seasonal fluctuations." }
          ]
        },
        {
          type: "paragraph",
          text: "Having millions in revenue might sound appealing, but a stable cash flow is what’s required for a business’s sustainable growth. Mastering cash flow isn’t optional; rather, it has become an important skill that every entrepreneur must learn. A healthy and stable cash flow is what differentiates a regular company from a successful company."
        },
        {
          type: "heading",
          text: "Take Control of Your Business Finances"
        },
        {
          type: "paragraph",
          text: "If you also want to learn how to manage cash flow like a pro from industry experts, Alfa Entrepreneur is the right place for you. Take control of your business finances and grow smartly without stress. Join Alfa Entrepreneurs now."
        }
      ],
      
      contentImage: "https://via.placeholder.com/600"
    },
];

export default function ArticleDetail() {
  const { id } = useParams<{ id: string }>();
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  const [articles, setArticles] = useState<Articles[]>(loggedOutArticles);

  useEffect(() => {
    setToken(localStorage.getItem('token')); // Reactively update token state
    if (token) {
      setArticles(loggedInArticles);
    } else {
      setArticles(loggedOutArticles);
    }
  }, [token]);

  const article = articles.find((article) => article.id === parseInt(id || '0'));

  if (!article) {
    return <div className="text-center text-xl text-red-600">Article not found</div>;
  }

  return (
    <div className="max-w-7xl mx-auto p-4 flex flex-col md:flex-row">
      <div className="w-full md:w-2/3 pr-4">
        <Link to="/Articles" className="text-indigo-600 hover:text-indigo-800 mb-4 inline-block">
          ← Back to Articles
        </Link>
        <h1 className="text-3xl font-bold mb-4">{article.title}</h1>

        {/* Article Image */}
        {article.contentImage && (
          <img src={article.contentImage} alt={article.title} className="mb-4 rounded-lg shadow-lg" />
        )}

        {/* Article Date */}
        <p className="text-gray-600 mb-4">{article.date}</p>

        {/* Article Content Rendering */}
        {article.content.map((item: { type: string; text: string | number | bigint | boolean | ReactElement<unknown, string | JSXElementConstructor<any>> | Iterable<ReactNode> | Promise<string | number | bigint | boolean | ReactPortal | ReactElement<unknown, string | JSXElementConstructor<any>> | Iterable<ReactNode> | null | undefined> | null | undefined; items: any[]; }, index: Key | null | undefined) => (
          <div key={index} className="mb-6">
            {item.type === 'heading' && <h2 className="text-xl font-semibold my-4">{item.text}</h2>}
            {item.type === 'paragraph' && <p className="mb-4">{item.text}</p>}
            {item.type === 'list' && (
              <ul className="list-disc ml-6 mb-4">
                {item.items?.map((listItem, idx) => (
                  <li key={idx} className="mb-2">
                    <strong>{listItem.title}:</strong> {listItem.description}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}